import axios from "@/plugins/axios";
import isBot from "@/plugins/isBot";
import * as Sentry from "@sentry/vue";
import {isOpenInEditor} from "@/plugins/Helpers";

function bindCloseElementEvent(element: Element): void {
    element.addEventListener('click', () => {
        try {
            window.localStorage?.setItem('country-redirect-closed', 'closed');
        } catch {}
        document.getElementsByClassName('cross-country-redirects')![0].remove();
        document.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('resize'));
        document.dispatchEvent(new Event('headerBarMove'));
    });
}

document.addEventListener('DOMContentLoaded', async () => {
    try {
        if (isOpenInEditor()) {
            return;
        }

        if (window.localStorage?.getItem('country-redirect-closed') === 'closed') {
            return;
        }

        if (isBot() || document.getElementById('header') === null) {
            return;
        }

        if (document.getElementsByClassName('cross-country-redirects').length > 0) {
            return;
        }

        const response = await axios.get('//' + window.location.host + '/api/ping');

        if ([429, 503, 504, 525].includes(response.status)) {
            return;
        }

        const {data} = response;
        if (typeof data !== 'string' || data.length === 0) {
            return;
        }

        const header: HTMLElement | null = document.getElementById('header');
        const headerBanners = header!.getElementsByClassName('banner');
        if (headerBanners.length > 0) {
            headerBanners[0].insertAdjacentHTML('beforebegin', data);
        } else {
            header!.insertAdjacentHTML('beforeend', data);
        }
        bindCloseElementEvent(document.getElementsByClassName('country-redirect-link')![0]);
        bindCloseElementEvent(document.getElementsByClassName('cross-country-redirects-close')![0]);

        document.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('resize'));
        document.dispatchEvent(new Event('headerBarMove'));
    } catch (error) {
        Sentry.captureException(error);
    }
});
